import type { Vec4 } from "eutopia.ts";

export const red: Vec4 = [1, 0.4, 0.4, 1];
export const green: Vec4 = [0.4, 1, 0.4, 1];
export const blue: Vec4 = [0.4, 0.4, 1, 1];
export const white: Vec4 = [1, 1, 1, 1];
export const black: Vec4 = [0, 0, 0, 1];
export const transparent: Vec4 = [0, 0, 0, 0];

export const scaleOpacity = ([r = 0, g = 0, b = 0, a = 0]: Vec4, k: number) =>
  [r, g, b, a * k] satisfies Vec4;

export const parseColor = (hex: string) => {
  const match = hex.match(/^#([0-9a-f]{6})$/i)?.[1];
  if (!match) throw new Error("Invalid color");
  return [
    ...[match.slice(0, 2), match.slice(2, 4), match.slice(4, 6)].map(
      _ => parseInt(_, 16) / 255,
    ),
    1,
  ] as [number, number, number, number];
};
